import React from "react";
import Navbar from "../components/Cripsr/NavbarCrispr";
import NarrativeSection from "../components/phones/NarrativeSection";
import EndOfStoryNav from "../components/phones/EndOfStoryNav";
import dogsteachHero from '../assets/images/dogs/Hero Images_Part II.png'
import dogswedoHero from '../assets/images/dogs/Hero Images_Part III.png'
import dogslove from '../assets/images/dogs/Hero Images_Part I.png'

import BecauseScienceFooter from "../components/phones/BecauseScienceFooter";
import floralPattern from "../assets/images/dogs/Floral Pattern - Dark.png";

import dogTip1 from '../assets/images/dogs/Dog Tip Illustration-01.png'
import dogTip2 from '../assets/images/dogs/Dog Tip Illustration-02.png'
import dogTip3 from '../assets/images/dogs/Dog Tip Illustration-03.png'
import dogTip4 from '../assets/images/dogs/Dog Tip Illustration-04.png'
import dogTip5 from '../assets/images/dogs/Dog Tip Illustration-05.png'

import sectionBreak1 from '../assets/images/dogs/Section Break-01.png'
import sectionBreak2 from '../assets/images/dogs/Section Break-02.png'
import sectionBreak3 from '../assets/images/dogs/Section Break-03.png'
import sectionBreak4 from '../assets/images/dogs/Section Break-04.png'
import sectionBreak5 from '../assets/images/dogs/Section Break-05.png'



export default function DogsWeCanDo() {

    const navLinks = [
        { label: "Does my dog love me?", href: "/dogs" },
        { label: "What dogs teach us", href: "/dogs/teach" },
        { label: "What we can do for our dogs", href: "/dogs/wecando" },
    ];
    return (
        <div className="w-full">

            <Navbar
                isShrunk={true}
                navLinks={navLinks}
                isFixed={true}
                bgColor="bg-[#fcf3e7]"
            />


            <div className="bg-[#fcf3e7]" >



                <NarrativeSection
                    id="shared-evolution"
                    containerWidth="max-w-md"
                    padY="py-0"
                    centeredImage={{ src: dogswedoHero, alt: "Dogs Teach illustration", widthClass: "w-[70%] sm:w-[80%]" }}
                    accentColor="#9f2b45"
                    content={[
                    ]}

                />

                <NarrativeSection
                    id="shared-evolution"
                    containerWidth="max-w-md"
                    padY="pt-28"
                    heading="What we can do for our dogs"

                    accentColor="#7B3F00"
                    content={[]}
                />

                <NarrativeSection
                    id="shared-evolution"
                    containerWidth="max-w-md"
                    padY="py-0"
                    accentColor="#9f2b45"
                    content={[
                        <div key="audio" className="text-center mb-8">
                            <p className="uppercase text-gray-500 text-xs tracking-wide mb-2">
                                Listen to this episode
                            </p>
                            <div className="flex justify-center">
                                <audio controls className="w-full max-w-md">
                                    <source src="/audio/friend-or-foe.mp3" type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        </div>,
                        `What our furry four-legged best friends do for us each day is immeasurable — they reduce stress, anxiety and depression, they ease loneliness and encourage exercise and playfulness, they even help strengthen communities — but have we ever considered what we should do for them?`,
                        `I don’t mean getting pawdicures, feeding them puppuccinos, or dressing them up for the next holiday photoshoot, because who are we kidding, that’s more for us then for them. So, what do our dogs want?`,
                        `Short of our dogs speaking for themselves we spoke to dog behavior experts, social psychology researchers and scanned the latest scientific literature to get insight into what we should be doing to give more comfort to these special family members in our everyday lives. `,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={dogTip1}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        <h3 key="carrot" className="text-[#9f2b45] font-bold text-xl sm:text-3xl mt-4">
                            1. Listen to your dog but recognize your own biases
                        </h3>,
                        `It turns out we may not understand our dogs as well as we think. New early research on dog emotional states finds that our perceptions of what our dogs are feeling relies rather less on anything our dogs do, but instead, more on the situation around them.`,
                        `“We tend to use anthropomorphism attributing human characteristics to our own dogs,” said Holly Molinaro, a social psychology researcher studying canine emotions. “When thinking about what we can do for our dog's welfare, the first thing we need to do is recognize the biases and emotions we project onto our pets.”`,
                        `Molinaro, a graduate scientist in the Canine Science Collaboratory lab at Arizona State University, conducted an experiment that played videos of a dog with his owner doing different things that should make the dog happy or sad – such as receiving a treat or being verbally disciplined. She then edited the videos so participants could only see the dog on a black background. `,
                        `When context was removed in this way, participants' interpretations differed significantly from when they were shown the original scenarios. In a second part of the experiment, she edited the videos to create mismatched scenarios. Molinaro took a video in which the dog had been disciplined, and edited it so that it looked like the dog was being given a treat.`,
                        `The research revealed that humans largely interpret dogs’ emotions by relying on the context rather than the dog's actual behavior. `,
                        `“We see a dog getting a treat, we say the dog's happy. We see the dog getting yelled at, we say the dog's sad. We look at the context, we don't actually look at the dog whatsoever,” said Molinaro. “The first thing that we can do is know how good or bad we are at understanding (our dogs). Step back and first take a look at yourself.”`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={sectionBreak1}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        `How it helps your dog: Better recognizing our biases when our dogs are stressed, anxious or in pain allows us to address issues early on, ensuring their comfort and well-being. Acknowledging when our four-legged friends are happy or content can also encourage positive behaviors and routines. `,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={dogTip2}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        <h3 key="carrot" className="text-[#9f2b45] font-bold text-xl sm:text-3xl mt-4">
                            2. For a dose of optimism, let their noses wander
                        </h3>,
                        `Dogs see the world through their noses. While humans have about six million olfactory receptors, dogs have 300 million. We know that dogs’ smell is the most important sense for understanding their surroundings, but new research has shown that regular nosework also may make them more optimistic. `,
                        `In a study with 20 adult dogs of various breeds including Australian Shepherds, Huskies and Cocker Spaniels, researchers from the Horowitz Dog Cognition Lab, Barnard College, in New York and the Ethodog Laboratory of Research in Canine Ethology, Paris, found that sniffing activities induced positive judgment bias in pet dogs. `,
                        `“I think the hardest thing for people to realize about their dog … is that they exist in this parallel perceptual world of smell, which we don’t spend a lot of time in, or even try to avoid,” said study author Alexandra Horowitz in a TED video discussing her research. `,
                        `“Every dog who I've seen who is allowed to live in that world a little bit more, sniff things they want to sniff, intentionally go out for smell walks, is a happier dog and I think people wind up more satisfied in understanding what their dogs are doing as well. So, take your dog for a smell walk.” `,
                        `In her study, after two weeks of either sniffing games or standard walks, dogs that engaged in nosework approached an ambiguous bowl more eagerly, indicating an optimistic expectation of a treat.`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={sectionBreak2}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        `How it helps your dog: Letting your dog do nosework training or playing a fun sniffing game, may make them happier, help their brain work better, and grow your bond. Allowing them to “read the newspaper of their environment” with their nose keeps them mentally stimulated.`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={dogTip3}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        <h3 key="carrot" className="text-[#9f2b45] font-bold text-xl sm:text-3xl mt-4">
                            3. Understand their communication cues
                        </h3>,
                        `Just as humans have different personalities and react to situations differently, so do our dogs. But according to experts there are certain ways our dogs communicate how they are feeling and what they need, provided we pay attention. `,
                        `Tail movements, for example, can reveal much about a dog’s feelings. A relaxed and fluid tail wag often signifies contentment, while a rigid, slight wag may indicate aggression. Research by neuroscientist Giorgio Vallortigara indicates that directional tail wagging is tied to brain activity, with right-side wags associated with positive emotions and left-side wags with negative ones.`,
                        `Additionally, to recognize your own dog’s distress experts recommend paying attention to signs like lip licking, yawning, paw lifting, hair shedding, scratching, shaking, panting, pacing, and the "whale eye" – visible whites of a dog's eye. `,
                        `“You have to look at the dog’s whole body, and you have to think about the context in which you’re in,” psychologist Sarah Byosiere, director of the Thinking Dog Center at CUNY Hunter College in New York City, told the New York Times. `,
                        `“Dogs are psychologically almost as diverse as they are physically diverse,” adds Clive Wynne, a behavioral psychologist who leads the Canine Science Collaboratory at Arizona State University. “Each of us needs to learn our own dog's way of communicating.”`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={sectionBreak3}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        `How it helps your dog: Understanding your dog's mode of communication ensures they are heard and understood. It reduces frustrations and potential behavior problems. Once you are aware of his or her unique language it’s much easier to understand your dog, communicate with them and strengthen your bond.`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={dogTip4}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        <h3 key="carrot" className="text-[#9f2b45] font-bold text-xl sm:text-3xl mt-4">
                            4. Use positive training methods
                        </h3>,
                        `There are many ways to train your dog and training concepts have changed a lot over time, but with more research into the canine brain, scientists and pet owners alike are finding new and better ways to connect with dogs that are more effective and more in line with how dogs think and learn. `,
                        `In a first-of-its-kind study to assess dog training methods in real-world settings, researchers in Portugal found that dogs who were trained using punishment-based methods showed higher stress levels compared to dogs trained with reward-based methods. `,
                        `The study involved nearly 100 dogs from seven dog training schools in Portugal. Dogs' cortisol levels were measured during training and revealed that dogs trained with aversive or mixed methods showed more stress behaviors and had higher stress hormone levels than those trained with rewards. Additionally, a cognitive bias test showed that dogs trained with aversive methods responded more negatively to ambiguous situations, suggesting a more pessimistic emotional state. `,
                        `“Our study points to the fact that the welfare of companion dogs trained with aversive-based methods is at risk, especially if these are used in high proportions,” the study authors wrote. `,
                        `Teaching your dog what you want her to do without fear, force or punishment, revolves around using rewards to send a message that the dog did a good job. This encourages the dog to do it again and again and learn the cues or words that you use to ask for that behavior. `,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={sectionBreak4}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        `How it helps your dog: Positive training methods build trust between you and your dog. It makes the learning process a fun and enriching experience for them, ensuring they are eager to learn and making them more mentally agile.`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={dogTip5}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        <h3 key="carrot" className="text-[#9f2b45] font-bold text-xl sm:text-3xl mt-4">
                            5. Give them the gift of time
                        </h3>,
                        `While dogs do a lot for us, the dominant role of our beloved pooches in the 21st century is to protect us from loneliness. Just as our dogs comfort us and keep us company, we need to think about their emotional needs in return. `,
                        `“Our dogs need our company just as we profit emotionally from their company,” said Wynne, the behavioral psychologist. “Dogs too suffer from separation anxiety and it’s completely understandable that a dog left alone for extended periods every day will become upset and distressed.”`,
                        `Dogs are social animals and thrive on companionship. In Sweden, for example, it's against the law to leave your dog home alone for more than four hours at a stretch. Wynne says we need to remember that the company and support dogs give us is a two-way street. If we’re away from our dogs for long periods of time for work, school or travel we should consider inviting a neighbor over to play with our furry friends or try a doggie daycare. `,
                        `“We need to give our dogs our time,” said Wynne. “That's really what they want. No toy or gadget can substitute for having loving people around them.”`,
                        <figure key="photo" className="flex justify-center mb-6">
                            <div className="w-[90%] sm:w-[100%]">
                                <img
                                    src={sectionBreak5}
                                    alt="Douglas Kenrick and son David Laughing-Kenrick"
                                    className="w-full rounded-sm "
                                />

                            </div>
                        </figure>,
                        `How it helps your dog: Spending quality time with your dog strengthens you and your dog’s emotional connection, alleviates their stress, reduces chances of future behavioral problems from inadequate attention, and supports reciprocal comfort.`


                    ]}

                />

                <EndOfStoryNav
                    bgColor="#fcf3e7"
                    accentColor="#9f2b45"
                    more={[
                        { href: "/dogs", title: "Does my dog love me", imageSrc: dogslove },
                        { href: "/dogs/teach", title: "What dogs have taught us", imageSrc: dogsteachHero },

                    ]}
                />
                <BecauseScienceFooter bgClass="" textClass="text-white" bgImage={floralPattern} />

            </div>
        </div>
    );
}